// extracted by mini-css-extract-plugin
export var activeDot = "_6i-c";
export var buttonContainer = "_6i-9";
export var channelButton = "_6i-a";
export var content = "_6i-0";
export var contentFull = "_6i-2";
export var contentThird = "_6i-1";
export var contentWrapper = "_6i-7";
export var description = "_6i-5";
export var heightShort = "_6i-e";
export var image = "_6i-3";
export var imageContainer = "_6i-4";
export var selectButton = "_6i-d";
export var spinnerContainer = "_6i-b";
export var titleContent = "_6i-8";
export var titleWrapper = "_6i-6";